module.exports = __webpack_public_path__ + "img/Lynch_ROE_PEG.fe5bf014.svg";